import { ComplexValue } from 'app/types-shared';

export const replaceSubscriptionError = (text: string, values: ComplexValue<number>[]) => {
  const mapped = text?.match(/[0-9]+/gi)?.map(item =>
    values.find(f => f.value === parseInt(item, 10))?.description).filter(key => !!key) ?? [];

  const result = mapped.join(', ');
  return result && text.replace(/\[(.+?)\]/g, result);
};
